import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getExcludedParentsQuery,
  getStudentFeedQuery,
  getJobFeedQuery,
  subTaskFeedQuery,
  getThirdPartyMappingQuery,
  getCourseFeedQuery,
  getTeacherFeedQuery,
  integrationTestSisConnectionQuery,
  getAvailableServicesQuery,
  getOrganizationCurriculumProgramsQuery,
  getOrganizationSubjectGroupsQuery,
  getExcludedEntitiesQuery,
  getEntityMappingsQuery,
  getLearningCoursesQuery,
  getAcademicCoursesQuery,
  getJobFeedForOneSchoolFileUploadQuery,
} from "./SyncQueries";

export const getSubTaskFromCache = ({ id, filters, first }) => {
  try {
    const queryData = client.readQuery({
      query: subTaskFeedQuery,
      variables: {
        first: first,
        id: id,
        filters: filters,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getJobFromCache = ({
  id,
  filters,
  first,
  curriculumProgramId,
  academicYearState,
  subTaskFilters,
  fetchSubTasksCount = false,
}) => {
  try {
    const queryData = client.readQuery({
      query: getJobFeedQuery,
      variables: {
        id: id,
        first,
        filters,
        curriculumProgramId,
        academicYearState,
        subTaskFilters,
        fetchSubTasksCount,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeJobFeedToCache = ({ data, variables }) => {
  try {
    client.writeQuery({
      query: getJobFeedQuery,
      variables: variables,
      data: {
        node: data,
      },
    });
  } catch (e) {}
};

export const getExcludedParentsFromCache = ({ input }) => {
  try {
    const queryData = client.readQuery({
      query: getExcludedParentsQuery,
      variables: {
        input: input,
      },
    });
    return _.get(queryData, "integration", {});
  } catch (e) {
    return {};
  }
};

export const getStudentFeedForOrganizationFromCache = ({
  studentFeedVariables,
}) => {
  try {
    const queryData = client.readQuery({
      query: getStudentFeedQuery,
      variables: studentFeedVariables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getThirdPartMappingFromCache = ({ id, input }) => {
  try {
    const queryData = client.readQuery({
      query: getThirdPartyMappingQuery,
      variables: {
        id,
        input,
      },
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeThirdPartMappingToCache = ({ id, input, data }) => {
  try {
    client.writeQuery({
      query: getThirdPartyMappingQuery,
      variables: {
        id,
        input,
      },
      data,
    });
  } catch (e) {}
};

export const getStaffFeedForOrganizationFromCache = ({
  teacherFeedVariables,
}) => {
  try {
    const queryData = client.readQuery({
      query: getTeacherFeedQuery,
      variables: teacherFeedVariables,
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationCourseFeedDataFormCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getCourseFeedQuery,
      variables: variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getLearningCourseFeedDataFormCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getLearningCoursesQuery,
      variables: variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getCourseCodeFeedDataFormCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getAcademicCoursesQuery,
      variables: variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getTestCredentialsResultFromCache = ({ input }) => {
  try {
    const queryData = client.readQuery({
      query: integrationTestSisConnectionQuery,
      variables: {
        input,
      },
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getAvailableServicesFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getAvailableServicesQuery,
      variables: variables,
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeAvailableServicesToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAvailableServicesQuery,
      variables,
      data,
    });
  } catch (e) {}
};

export const writeStudentFeedForOrganizationFromCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getStudentFeedQuery,
      variables: variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const writeCourseFeedForOrganizationFromCache = ({
  variables,
  data,
}) => {
  try {
    client.writeQuery({
      query: getCourseFeedQuery,
      variables: variables,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const writeLearningCourseDataToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getLearningCoursesQuery,
      variables: variables,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const writeCourseCodeDataToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getAcademicCoursesQuery,
      variables: variables,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const writeExcludedParentsFromCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getExcludedParentsQuery,
      variables: variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const writeStaffFeedForOrganizationFromCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getTeacherFeedQuery,
      variables: variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const writeSubTaskToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: subTaskFeedQuery,
      variables: variables,
      data: data,
    });
  } catch (e) {
    return {};
  }
};

export const getOrganizationCurriculumProgramsFromCache = organizationId => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationCurriculumProgramsQuery,
      variables: {
        organizationId,
      },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationSubjectGroupsFromCache = ({
  id,
  filters,
  subjectFilters,
}) => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationSubjectGroupsQuery,
      variables: { id, filters, subjectFilters },
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getExcludedTpsEntitiesFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getExcludedEntitiesQuery,
      variables,
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const writeExcludedTpsEntitiesToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getExcludedEntitiesQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getEntityMappingsFromCache = ({ variables }) => {
  try {
    const queryData = client.readQuery({
      query: getEntityMappingsQuery,
      variables,
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const writeEntityMappingsToCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getEntityMappingsQuery,
      variables,
      data,
    });
  } catch (e) {
    return {};
  }
};

export const getOneSchoolUploadQueryVars = ({
  organizationId,
  curriculumId,
  uploadType,
}) => ({
  id: organizationId,
  curriculumProgramId: curriculumId,
  filters: { jobType: [uploadType], syncLatest: true },
  first: 1,
});

export const writeOneSchoolLatestJobToCache = ({
  organizationId,
  curriculumId,
  uploadType,
  jobData,
}) => {
  try {
    const variables = getOneSchoolUploadQueryVars({
      organizationId,
      curriculumId,
      uploadType,
    });

    let existingNode = {};
    let existingJobFeed = {};
    let edgeTypename = "OrganizationIntegrationJobEdges";

    try {
      const existingData = client.readQuery({
        query: getJobFeedForOneSchoolFileUploadQuery,
        variables,
      });
      if (existingData) {
        existingNode = _.get(existingData, "node", {});
        existingJobFeed = _.get(existingData, "node.jobFeed", {});
        edgeTypename =
          _.get(existingData, "node.jobFeed.edges[0].__typename") ||
          edgeTypename;
      }
    } catch {}

    client.writeQuery({
      query: getJobFeedForOneSchoolFileUploadQuery,
      variables,
      data: {
        node: {
          ...existingNode,
          __typename: "Organization",
          id: organizationId,
          jobFeed: {
            ...existingJobFeed,
            totalCount: 1,
            edges: [
              {
                __typename: edgeTypename,
                node: { __typename: "IntegrationJob", ...jobData },
              },
            ],
            pageInfo: {
              __typename: "PageInfo",
              hasNextPage: false,
              endCursor: null,
            },
          },
        },
      },
    });
  } catch {}
};
